import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NotificationService } from 'src/app/services/notification.service';
import { Subscription, finalize, interval, startWith, switchMap } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
    @ViewChild('notificationsPopover') notificationsPopover!: PopoverDirective;

    private authRefreshSubscription!: Subscription;
    // Used to close the popover when clicking outside of the navbar component
    private globalClickListener!: () => void;

    username: string = '';
    usernameLetters: string = '';
    userDirectie: string = '';
    userCompartiment: string = '';
    userNotifications!: string;
    panelOpenState = false;
    isPopoverOpen: boolean = false;
    activeRoute = '';
    isLoading = true;
    env = environment;
    public isMenuOpen: boolean = false;
    public notification: { [key: string]: string } = {};

    constructor(
        private storageService: StorageService,
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private notificationService: NotificationService,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        public permissionsService: PermissionsService,
    ) {
        this.activeRoute = router.url;
    }

    public onSidenavClick(): void {
        this.isMenuOpen = false;
    }
    ngOnInit(): void {
        this.processUserDetails();
        this.initGlobalClickListener();
        this.startCount();
    }

    ngOnDestroy() {
        if (this.authRefreshSubscription) {
            this.authRefreshSubscription.unsubscribe();
        }
        if (this.globalClickListener) {
            this.globalClickListener();
        }
    }

    // Used to close the popover when clicking outside of the navbar component
    initGlobalClickListener() {
        this.globalClickListener = this.renderer.listen('document', 'click', (event) => {
            if (this.notificationsPopover && !this.elementRef.nativeElement.contains(event.target)) {
                this.closeNotificationPopover();
            }
        });
    }

    logout() {
        this.router.navigate(['/']);
    }

    processUserDetails() {
        var self = this;
        setTimeout(() => {
            const userObj = self.storageService.getObject(environment.config.userKey);
            userObj
                .then((val) => {
                    self.username = val.name;
                    self.userDirectie = val.name_sesizare_departament || '';
                    self.userCompartiment = val.name_sesizare_compartiment || '';
                    self.extractLetters(self.username);
                })
                .catch((err) => {
                    self.username = 'Not logged in';
                    console.log(err);
                });
        }, 300);
    }

    extractLetters(username: string) {
        const firstLetters = username.split(' ').map((word) => word.charAt(0));
        this.usernameLetters = firstLetters.slice(0, 2).join('');
    }

    setActiveRoute(value: string) {
        this.activeRoute = value;
    }

    closeNotificationPopover(): void {
        if (this.notificationsPopover) {
            this.notificationsPopover.hide();
            this.isPopoverOpen = false;
        }
    }

    onButtonClick(value: { id: string; name: string }) {
        this.closeNotificationPopover();
        this.notificationService.changeNotification(value);
        this.router.navigate(['/cereri']);
    }

    navigateToProfile(): void {
        this.router.navigate(['/user-profile']);
    }

    startCount() {
        this.authRefreshSubscription = interval(120000) // 120,000 milliseconds = 2 minutes
            .pipe(
                startWith(0), // startwith 0 ca primul call sa fie facut de la 0, fara sa asteptam cele 2 minute de mai sus
                switchMap(() => {
                    this.isLoading = true;
                    return this.notificationService
                        .getNotifications()
                        .pipe(finalize(() => (this.isLoading = false)));
                })
            )
            .subscribe({
                next: (response: any) => {
                    if (response) {
                        const data = response;

                        let totalNotifications = 0;

                        Object.keys(data).forEach((key) => {
                            const value = data[key];
                            if (typeof value === 'number') {
                                this.notification[key] = value.toString();

                                totalNotifications += value;
                            }
                        });

                        this.userNotifications = totalNotifications.toString();
                    } else {
                        console.warn('Response data is undefined or null');
                    }

                    this.isLoading = false;
                },
                error: (error) => {
                    console.error('Error fetching notifications:', error);
                    this.isLoading = false;
                },
            });
    }
}
